import { Link } from "react-router-dom";
import { Wordmark } from "./design";

export default function PublicFooter() {
  return (
    <footer
      style={{
        background: "var(--paper-200)",
        borderTop: "1px solid rgba(43,26,15,0.10)",
      }}
    >
      <div
        style={{
          maxWidth: 960,
          margin: "0 auto",
          padding: "32px 22px 40px",
          display: "flex",
          flexDirection: "column",
          gap: 22,
          fontFamily: "var(--f-ui)",
          fontSize: 12,
          color: "var(--ink-faint)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <Wordmark size={20} />
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
            gap: 22,
          }}
        >
          <FooterColumn title="Mehr erfahren">
            <FooterRouterLink to="/biografie-schreiben-lassen">
              Biografie schreiben lassen
            </FooterRouterLink>
            <FooterRouterLink to="/wie-funktioniert-vitanara">
              Wie funktioniert Vitanara?
            </FooterRouterLink>
            <FooterRouterLink to="/pakete">Pakete</FooterRouterLink>
            <FooterRouterLink to="/preise">Preise</FooterRouterLink>
            <FooterRouterLink to="/lebensgeschichte-als-hoerbuch">
              Lebensgeschichte als Hörbuch
            </FooterRouterLink>
            <FooterRouterLink to="/lebensgeschichte-als-podcast">
              Lebensgeschichte als Podcast
            </FooterRouterLink>
          </FooterColumn>

          <FooterColumn title="Geschenk-Ideen">
            <FooterRouterLink to="/geschenk-fuer-oma">
              Geschenk für Oma
            </FooterRouterLink>
            <FooterRouterLink to="/geschenk-fuer-opa">
              Geschenk für Opa
            </FooterRouterLink>
            <FooterRouterLink to="/goldene-hochzeit-geschenk">
              Goldene Hochzeit
            </FooterRouterLink>
          </FooterColumn>

          <FooterColumn title="Service">
            <FooterRouterLink to="/faq">FAQ</FooterRouterLink>
            <FooterRouterLink to="/ueber-uns">Über uns</FooterRouterLink>
            <FooterRouterLink to="/login">Login</FooterRouterLink>
            <a
              href="mailto:info@vitanara.de"
              style={{ color: "var(--ink-faint)", textDecoration: "none" }}
            >
              info@vitanara.de
            </a>
          </FooterColumn>

          <FooterColumn title="Rechtliches">
            <FooterRouterLink to="/impressum">Impressum</FooterRouterLink>
            <FooterRouterLink to="/datenschutz">Datenschutz</FooterRouterLink>
            <FooterRouterLink to="/agb">AGB</FooterRouterLink>
          </FooterColumn>
        </div>

        <div
          style={{
            marginTop: 4,
            fontFamily: "var(--f-body)",
            fontStyle: "italic",
            fontSize: 12,
            color: "var(--ink-faint)",
          }}
        >
          © {new Date().getFullYear()} Vitanara · Mit Liebe aus Schleswig-Holstein.
        </div>
      </div>
    </footer>
  );
}

function FooterColumn({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <div>
      <div
        className="t-caps"
        style={{
          marginBottom: 10,
          fontSize: 11,
          letterSpacing: "0.12em",
          color: "var(--ink-soft)",
        }}
      >
        {title}
      </div>
      <nav style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        {children}
      </nav>
    </div>
  );
}

function FooterRouterLink({
  to,
  children,
}: {
  to: string;
  children: React.ReactNode;
}) {
  return (
    <Link
      to={to}
      style={{
        color: "var(--ink-faint)",
        textDecoration: "none",
        fontSize: 13,
      }}
    >
      {children}
    </Link>
  );
}
